export const INVOICE_LIST = 'INVOICE_LIST';
export const MY_INVOICE = 'MY_INVOICE'; 
export const INVOICE_DETAIL = 'INVOICE_DETAIL';
